<template>
  <div class="sm:container my-20">
    <div class="grid grid-cols-3 gap-10">
      <div class="col-span-3 sm:col-span-1">
        <div v-if="boxTitle" class="text-white flex flex-col box relative sm:sticky sm:top-32">
          <h3 class="fluid-3xl leading-tightest" v-html="boxTitle"></h3>
          <CtaArrow v-if="boxCta" v-bind="boxCta" class="cta-arrow mt-4" />
        </div>
      </div>
      <div class="px-3 sm:px-0 col-span-3 sm:col-span-2 sm:gap-4 masonry">
        <StoryPreview
          v-for="(story, index) in stories"
          :key="index"
          class="transform my-10 sm:pb-4"
          style="break-inside: avoid"
          :always-column="false"
          :aspect-ratio="index % 2 === 1 ? 1 : 1.5"
          :class="index < stories.length / 2 ? 'sm:-translate-y-20' : 'sm:translate-y-20'"
          :story="story"
        />
      </div>
    </div>
  </div>
</template>

<script>
import StoryPreview from '@/components/stories/StoryPreview';
import CtaArrow from '@/components/common/CtaArrow';

export default defineNuxtComponent({
  components: {
    StoryPreview,
    CtaArrow,
  },
  props: {
    boxTitle: {
      type: String,
      default: '',
    },
    stories: {
      type: Array,
      default: () => [],
    },
    boxCta: {
      type: [Object, String],
      default: () => null,
    },
  },
});
</script>
